var _toConsumableArray = require("D:\\GithubDesktop\\Echo\\echograde\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

module.exports = function (chunkFunc) {
  return function (arr, yearData) {
    return [].concat(_toConsumableArray(arr), _toConsumableArray(yearData.reduce(function (years, row) {
      return chunkFunc(row) ? [].concat(_toConsumableArray(years), [[row]]) : [].concat(_toConsumableArray(years.slice(0, -1)), [[].concat(_toConsumableArray(years.slice(-1)[0]), [row])]);
    }, [])));
  };
};